import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PageFallback } from './PageFallback';

/** Origem da plataforma Shiba — para onde os deep links de console migram. */
export const PLATFORM_URL = 'https://www.shiba.ia.br';

/**
 * Saída dos deep links antigos da plataforma (`/app*`, `/perfis*`, …) que este
 * bundle NÃO tem: redirect client-side para o equivalente em www.shiba.ia.br,
 * preservando caminho e query. O 301 de borda é de outro workstream — este é o
 * amortecedor para quem chegar aqui enquanto ele não existe.
 */
export function PlatformRedirect(): JSX.Element {
  const location = useLocation();

  useEffect(() => {
    window.location.replace(
      `${PLATFORM_URL}${location.pathname}${location.search}${location.hash}`,
    );
  }, [location]);

  return <PageFallback />;
}
